import React from "react";
import styled from "styled-components";
import { Link } from "react-router";
import { useTranslation } from "react-i18next";

//
import SERVICELIST from "../assets/data/service-list";

export default function Service() {
  const { t } = useTranslation();

  return (
    <StyledService>
      <div className="container">
        <div className="service__wrap">
          <div className="service__top">
            <h1>{t("serviceSectionTitle")}</h1>
            <p>{t("serviceSectionText")}</p>
          </div>
          <div className="service__bottom">
            <ul className="service__list">
              {SERVICELIST.map((i) => (
                <li key={i.id} className="service__list__item">
                  <Link to={i.to}>
                    <div>
                      <i className={"icon " + i.icon} aria-hidden="true"></i>
                      <h2>{t(i.title)}</h2>
                    </div>
                    {/* <p>{i.number}</p> */}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="service__link">
            <Link to="/service/all" className="hover-underline">
              {t("serviceLinkText")} {">>"}
            </Link>
          </div>
        </div>
      </div>
    </StyledService>
  );
}

const StyledService = styled.section`
  padding: 140px 0;

  .service {
    &__top {
      h1 {
        color: var(--title);
        text-align: center;
        font-size: var(--fs-section-title);
        font-style: normal;
        font-weight: var(--fw-semibold);
        line-height: var(--lh-title);
        margin-bottom: var(--space-title-subtitle);
      }

      p {
        color: var(--text);
        text-align: center;
        font-size: var(--fs-subtitle);
        font-style: normal;
        font-weight: var(--fw-regular);
        line-height: var(--lh-subtitle);
      }
    }

    &__list {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 40px;
      margin: 48px 0;

      &__item {
        & > a {
          min-height: 132px;
          height: 132px;
          background-color: var(--bg);
          border: 1px solid var(--border);
          padding: 30px 44px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          gap: 28px;
          position: relative;

          &::before {
            content: "";
            position: absolute;
            top: -1px;
            left: -1px;
            width: 0;
            height: 2px;
            background-color: var(--light-blue);
            transition: 0.4s ease;
          }

          &::after {
            content: "";
            position: absolute;
            bottom: -1px;
            right: -1px;
            width: 0;
            height: 2px;
            background-color: var(--light-blue);
            transition: 0.4s ease;
          }

          div {
            display: flex;
            align-items: center;
            gap: 28px;
            width: 100%;

            i {
              min-width: 52px;
              width: 52px;
              height: 52px;
              background-color: var(--light-blue);
              opacity: 0.8;
              vertical-align: top;
            }

            h2 {
              color: var(--title);
              font-size: var(--fs-card-title);
              font-style: normal;
              font-weight: var(--fw-semibold);
              line-height: 1.35;
            }
          }

          p {
            color: var(--extra-light-blue);
            opacity: 0.5;
            font-size: 56px;
            font-style: normal;
            font-weight: 600;
            line-height: 62px; /* 114% */
            transition: 0.4s ease;
          }

          &:hover {
            &::after,
            &::before {
              width: 60%;
            }

            div {
              i {
                transform: scale(1.2);
              }

              h2 {
                transition: 0.4s ease;
                color: var(--light-blue);
              }
            }

            p {
              opacity: 1;
            }
          }
        }
      }
    }

    &__link {
      display: flex;
      justify-content: center;

      & > a {
        color: var(--dark-blue);
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 147.059% */

        &::after {
          background-color: var(--dark-blue);
        }
      }
    }
  }
`;
